// Module
var code = `<p class="title">Pledge deposit deviation interval fee board:</p>

<div class="alert">
  Please note: In case of missing rows default rate will be used for calculation
</div>
<div class="form-section">
  <form-section-field
    auto-width-title="true"
    field-title="'Default value'"
    ng-if="\$ctrl.feeType === 'FIXED'">
    <cash class="custom-fee-board__default-rate"
          ng-model="\$ctrl.board.defaultFixedAmount"
          ng-required="true"
    ></cash>
  </form-section-field>
  <form-section-field auto-width-title="true" field-title="'Default rate'" ng-if="\$ctrl.feeType === 'PERCENTAGE'">
    <glue-container append-percentage="true" class="custom-fee-board__default-rate">
      <input
        max="1000"
        min="0"
        ng-model="\$ctrl.board.defaultPercentageAmount"
        required
        step="0.00001"
        type="number">
    </glue-container>
  </form-section-field>
</div>

<table class="center-table table table-hover table-style table--generate-row-ids">
  <thead>
  <tr>
    <th>No.</th>
    <th>Payment interval</th>
    <th>
      Fee {{\$ctrl.feeType === 'FIXED' ? 'amount' : 'percentage'}}
    </th>
    <th>Action</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="cell in \$ctrl.board.cells">
    <td />
    <td>
      <select
              ng-model="cell.paymentInterval"
              ng-options="i.value as i.label for i in \$ctrl.getAvailablePaymentIntervals(cell.paymentInterval)"
              required></select>
    </td>
    <td class="fee" ng-if="\$ctrl.feeType === 'FIXED'">
      <cash class="custom-fee-board__default-rate"
            ng-model="cell.fixedAmount"
            ng-required="true"
      ></cash>
    </td>
    <td class="fee" ng-if="\$ctrl.feeType === 'PERCENTAGE'">
      <glue-container append-percentage="true" class="custom-fee-board__default-rate">
        <input
          max="1000"
          min="0"
          ng-model="cell.percentageAmount"
          required
          step="0.00001"
          type="number">
      </glue-container>
    </td>
    <td>
      <button class="btn btn-danger" ng-click="\$ctrl.removeBoardCell(\$index)" type="button">
        Remove
      </button>
    </td>
  </tr>
  </tbody>
  <tfoot>
  <tr>
    <td />
    <td />
    <td />
    <td>
      <button class="btn btn-primary"
              ng-click="\$ctrl.addNewBoardCell()"
              type="button"
              ng-disabled="!\$ctrl.enableAddNewButton">
        Add new
      </button>
    </td>
  </tr>
  </tfoot>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/charge/pledge-deposit-deviation-interval-fee-board.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;